import { styled } from '@uhg-abyss/web/tools/styled';
import { Text } from '@uhg-abyss/web/ui/Text';

export const DirectoryPhoneItem = styled('div', {
  paddingBottom: '24px',
  '&:first-child': {
    paddingTop: 0,
  },
  '&:last-child': {
    marginBottom: 0,
    paddingBottom: 0,
  },
});

export const DirectoryPhoneContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '16px',
});

export const ShowAllButton = styled('button', {
  display: 'flex',
  alignItems: 'center',
  variants: {
    mobile: {
      true: {
        marginLeft: '30px',
        marginBottom: '12px',
      },
      false: {
        marginLeft: 0,
      },
    },
  },
  '@screen < $md': {
    marginTop: '12px',
  },
});

export const ShowAllText = styled(Text, {
  color: '$core.color.brand.60',
  fontStyle: 'normal',
  fontWeight: 'bold',
  fontSize: '$md',
  lineHeight: '$md',
  '&.abyss-text-root': {
    '@media (max-width: 464px)': {
      fontSize: '$md',
      lineHeight: '$md',
    },
  },
});
